import React from "react";
import { Dimensions, View, Text, TextInput, StyleSheet, TouchableOpacity, Linking,
         Image, Platform, RefreshControl, Alert } from "react-native";
import { Container, Content, Tab, Tabs, Icon, Left, Right, Body, Button, ActionSheet } from "native-base";
import Header from "../../components/ui/WrappedHeader";
import { connect } from "react-redux";
import WrappedFlatList from "../../components/ui/WrappedFlatList";
import LoadingIndicator from "../../components/ui/LoadingIndicator";
import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../redux/screens/bbs/MyActivityRedux";
import { NavigationService } from "../../navigation";
import NavigateActionTypes from "../../navigation/NavigateActionTypes";
import UIDs from "../../UIDs";
import * as Helper from "../../utils/Helper";
import { withTranslation } from "react-i18next";
import AuthorizedScreen from "../../components/base/AuthorizedScreen";
import _ from "lodash"
import { AppSizes, AppStyles } from "../../theme";
import CustomText from "../../components/ui/CustomText";
import MaterialIcons from "react-native-vector-icons/MaterialIcons";
import AntdIcon from "react-native-vector-icons/AntDesign";
import AppColors from "../../theme/colors";
import MessageBox from "../../components/ui/MessageBox";
import AppConfig from "../../config/AppConfig";
import dayjs from "dayjs";
import PostImage from "../../components/ui/PostImage";
import HTMLView from "../../../components/ui/HTMLView";

const uid = UIDs.screens.bbs.myactivity;

class MyActivityScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: { done: null, error: this._handleAsyncActionError },
            [ActionTypes.LOAD_MORE_POST_ASYNC]: { done: null, error: this._handleAsyncActionError },
            [ActionTypes.LOAD_MORE_REPLY_ASYNC]: { done: null, error: this._handleAsyncActionError },
            [ActionTypes.LOAD_MORE_FAVOURITE_ASYNC]: { done: null, error: this._handleAsyncActionError },
        };
    }

    get isLogoutScreen() {
        return true;
    }

    localVars = {
        navParams: {},
        activeTab: 0,
        firstLoad: true,
        downloadLink: null,
    };

    constructor(props) {
        super(props);
        //this.localVars.navParams = NavigationService.getNavParams(props);
        this.state = {
            text: '',
        }
    }

    componentDidMount() {
        super.componentDidMount();

        this.props.loadScreenViewAsync({});
        //this.props.navigation.setParams({ reQuery: this.props.refreshScreenAsync });
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    handleBackPress = () => {
        // 一级Screen不处理Back键
        return false;
    };

    changeActiveTab(index) {
        this.props.changeActiveTab(index);

        setTimeout(() => {
            const data = this.currentList();
            if (data.length === 0) {
                this.props.refreshScreenAsync();
            }
        }, 10);
    }

    currentList() {
        const { activeTab, postList, replyList, favouriteList } = this.props.localState;
        const lists = [postList, replyList, favouriteList];
        const index = activeTab;
        return lists[index];
    }

    currentListParams() {
        const { activeTab, postListParams, replyListParams, favouriteListParams } = this.props.localState;
        const params = [postListParams, replyListParams, favouriteListParams];
        const index = activeTab;
        return params[index];
    }

    renderScreen() {
        if (!this.isActionDone(ActionTypes.LOAD_SCREEN_VIEW_ASYNC)) return <LoadingIndicator />;

        const { postCount, replyCount, favouriteCount,
                activeTab, postList, replyList, favouriteList } = this.props.localState;
        return (
            <Container>
                <View style={{flexDirection: 'row', backgroundColor: '#fff', alignItems: 'center',
                              borderTopWidth: 4, borderTopColor: '#f7f7f7',
                              justifyContent: 'space-around',
                              paddingHorizontal: 20, paddingVertical: 20}}>
                    {/*<View style={styles.topitem}>
                        <Image source={require("../../images/bbs/post.png")} style={styles.topimg} resizeMode="contain"></Image>
                        <View style={styles.toptextv}>
                            <Text style={styles.toptext1}>{postCount}</Text>
                            <Text style={styles.toptext2}>{this.props.t('post')}</Text>
                        </View>
                    </View>*/}
                    <View style={styles.topitem}>
                        <Image source={require("../../images/bbs/reply.png")} style={styles.topimg} resizeMode="contain"></Image>
                        <View style={styles.toptextv}>
                            <Text style={styles.toptext1}>{replyCount}</Text>
                            <Text style={styles.toptext2}>{this.props.t('reply')}</Text>
                        </View>
                    </View>
                    <View style={styles.topitem}>
                        <Image source={require("../../images/bbs/favourite.png")} style={styles.topimg} resizeMode="contain"></Image>
                        <View style={styles.toptextv}>
                            <Text style={styles.toptext1}>{favouriteCount}</Text>
                            <Text style={styles.toptext2}>{this.props.t('favourite')}</Text>
                        </View>
                    </View>
                </View>
                <View style={{flexDirection: 'row', backgroundColor: '#f7f7f7',
                              alignItems: 'center', justifyContent: 'center', paddingVertical: 10}}>
                    {/*<TouchableOpacity style={{flexDirection: 'row', alignItems: 'center',
                                              borderTopLeftRadius: 6,
                                              borderBottomLeftRadius: 6,
                                              backgroundColor: (activeTab === 0 ? '#fdaf2c' : '#fff'),
                                              height: 26, paddingHorizontal: 16}}
                                      onPress={() => this.changeActiveTab(0)}>
                        <Text style={{fontSize: 13, color: (activeTab === 0 ? '#fff' : '#999')}}>
                            {this.props.t('myPost')}
                        </Text>
                    </TouchableOpacity>*/}
                    <TouchableOpacity style={{flexDirection: 'row', alignItems: 'center',
                                              borderTopLeftRadius: 6,
                                              borderBottomLeftRadius: 6,
                                              backgroundColor: (activeTab === 1 ? '#fdaf2c' : '#fff'),
                                              height: 26, paddingHorizontal: 16}}
                                      onPress={() => this.changeActiveTab(1)}>
                        <Text style={{fontSize: 13, color: (activeTab === 1 ? '#fff' : '#999')}}>
                            {this.props.t('myReply')}
                        </Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={{flexDirection: 'row', alignItems: 'center',
                                              borderTopRightRadius: 6,
                                              borderBottomRightRadius: 6,
                                              backgroundColor: (activeTab === 2 ? '#fdaf2c' : '#fff'),
                                              height: 26, paddingHorizontal: 16}}
                                      onPress={() => this.changeActiveTab(2)}>
                        <Text style={{fontSize: 13, color: (activeTab === 2 ? '#fff' : '#999')}}>
                            {this.props.t('myFavourite')}
                        </Text>
                    </TouchableOpacity>
                </View>
                {this._renderList()}
                {this.isActionExecuting(ActionTypes.LOAD_SCREEN_VIEW_ASYNC) ? <LoadingIndicator /> : null}
            </Container >
        );
    }

    _renderEmpty() {
        return (<View style={styles.noneContainer}>
                    <Image source={require("../../images/homework/noRecord.png")} style={styles.noneImage} resizeMode="contain"></Image>
                    <CustomText style={styles.noneText}>{this.props.t("noPost")}</CustomText>
                </View>);
    }

    _renderList = () => {
        const data = this.currentList();
        const { activeTab } = this.props.localState;
        const renderItems = [this._renderPostItem, this._renderReplyItem, this._renderFavouriteItem];
        const loadMores = [this._loadMorePost, this._loadMoreReply, this._loadMoreFavourite];
        return (
            <View style={data && data.length > 0 ? styles.listContainer : styles.emptyContainer}>
                <WrappedFlatList
                    data={data}
                    keyExtractor={item => item.id}
                    renderItem={data => renderItems[activeTab](data)}
                    ListEmptyComponent={this._renderEmpty()}
                    ItemSeparatorComponent={this._separator}
                    refreshControl={
                        <RefreshControl
                            tintColor="#ffb007"
                            colors={["#ffb007"]}
                            refreshing={this.isActionExecuting(ActionTypes.REFRESH_SCREEN_ASYNC)}
                            onRefresh={() => this.props.refreshScreenAsync()}
                        />
                    }
                    onEndReached={() => loadMores[activeTab]()}
                    onEndReachedThreshold={0.1}
                />
            </View>
        )
    }

    _renderUserIcon = (icon) => {
        if (!icon) {
            return null;
        }
        if (icon.isUseAvatar) {
            return (<View style={{width: 28, height: 28, borderRadius: 14,
                                  alignItems: 'center', justifyContent: 'center',
                                  backgroundColor: icon.avatarBackgroundColor}}>
                    <Text style={{fontSize: 18, color: '#fff'}}>{icon.avatarName}</Text>
                    </View>);
        }
        return (<View style={{width: 28, height: 28, borderRadius: 14, overflow: 'hidden',
                              alignItems: 'center', justifyContent: 'center'}}>
                    <Image style={{width: 28, height: 28}}
                           source={{uri: Helper.convertToAbsoluteUrl(icon.photo)}}/>
                </View>);
    }

    _renderImage = (it, i) => {
        return (<View key={i} style={{width: 50, height: 50, marginRight: 8,
                                      alignItems: 'center', justifyContent: 'center'}}>
                    <PostImage style={{width: 50, height: 50}}
                               source={{uri: Helper.convertToAbsoluteUrl(it)}}/>
                </View>);
    };

    _renderReplyReply = (item, i, count) => {
        const content = JSON.parse(item.data);
        return (
            <View key={i} style={{flexDirection: 'column', borderBottomWidth: (i < count - 1) ? 1 : 0,
                                  paddingVertical: 8, borderBottomColor: '#f0f0f0'}}>
                <View style={{flexDirection: 'column', paddingRight:25}}>
                    {content.html ?
                     (<HTMLView html={content.html}/>) :
                     (<Text style={{}}>{content.text}</Text>)}
                    {content.files && content.files.length > 0 ?
                     (<View style={{marginTop: 8, marginBottom: 8,
                                    flexDirection: 'row', alignItems: 'center'}}>
                          {content.files.map(this._renderImage)}
                      </View>) : null}
                    <Text style={{ marginTop: 2, fontSize: 12, color: "#999" }}>{dayjs.utc(item.updateOn).local().format('YYYY-MM-DD HH:mm')}</Text>
                </View>
                <View style={{position: 'absolute', top: 8, right: 0}}>
                    <TouchableOpacity onPress={() => this._handleReplyMenu(item)}>
                        <AntdIcon name={"ellipsis1"} style={{ fontSize: 24, color: '#999' }} />
                    </TouchableOpacity>
                </View>
            </View>
        );
    };

    _renderReplyItem = (data) => {
        const { item } = data;
        const reply = (item.replyList && item.replyList.length > 0) ? item.replyList[0] : {};
        const tags = item.tags ? item.tags.split('\n') : [];
        return (<View style={styles.favitem}>
                    <View style={{flexDirection: 'row', alignItems: 'center', marginTop: 4, marginBottom: 4}}>
                        {this._renderUserIcon(reply.fromUserIcon)}
                        <Text style={{marginLeft: 4, color: '#444'}}>{this.props.t("reply")}:</Text>
                    </View>
                    {item.replyList.map((it, i) => this._renderReplyReply(it, i, item.replyList.length))}
                    <View style={{flexDirection: 'column', backgroundColor: '#f7f7f7', borderRadius: 8,
                                  marginTop: 4, paddingHorizontal: 10, paddingVertical: 10}}>
                        <View style={{flexDirection: 'row', alignItems: 'center'}}>
                            <TouchableOpacity style={{flexDirection: 'row', alignItems: 'center'}}
                                              onPress={() => this._handleDetails(item.id)}>
                                {this._renderUserIcon(item.userIcon)}
                                <Text style={{marginLeft: 4, color: '#444'}}>{item.userName}</Text>
                                {item.isTeacher ?
                                 (<View style={{backgroundColor: '#fdaf2c', paddingHorizontal: 4,
                                                paddingVertical: 2, borderRadius: 4,
                                                alignItems: 'center', justifyContent: 'center'}}>
                                      <Text style={{fontSize: 12, color: '#fff'}}>{this.props.t('teacher')}</Text>
                                  </View>) : null}
                            </TouchableOpacity>
                        </View>
                        <TouchableOpacity style={{marginTop: 8, flexDirection: 'row', alignItems: 'center',
                                                  flexWrap: 'wrap'}}
                                          onPress={() => this._handleDetails(item.id)}>
                            {item.isSticky ?
                             (<View style={{backgroundColor: '#62c863', paddingHorizontal: 4,
                                            paddingVertical: 2, borderRadius: 4, marginRight: 4,
                                            alignItems: 'center', justifyContent: 'center'}}>
                                  <Text style={{fontSize: 12, color: '#fff'}}>{this.props.t('stickyTag')}</Text>
                              </View>) : null}
                            {item.isDigest ?
                             (<View style={{backgroundColor: '#ef4736', paddingHorizontal: 4,
                                            paddingVertical: 2, borderRadius: 4, marginRight: 4,
                                            alignItems: 'center', justifyContent: 'center'}}>
                                  <Text style={{fontSize: 12, color: '#fff'}}>{this.props.t('digestTag')}</Text>
                              </View>) : null}
                            {item.title ? item.title.split("").map(c => (<Text style={{fontSize: 16}}>{c}</Text>)) : null}
                        </TouchableOpacity>
                        {(tags && tags.length > 0) ?
                         (<View style={{marginTop: 2, flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap'}}>
                              {tags.map((tag, i) => (<Text key={i} style={{fontSize: 16, color: '#3d82f1', marginRight: 4}} onPress={() => {
                                                                       this._handleSearch('#' + tag);
                                                                       }}>
                                                         #{tag}
                                                     </Text>))}
                          </View>) : null}
                    </View>
                    <View style={{marginTop: 8, flexDirection: 'row', alignItems: 'center', flex:1, flexWrap:"wrap"}}>
                        {
                            item.classPostList && item.classPostList.length > 0 ?
                                item.classPostList.map((itemClass, z) => {
                                    return(
                                        <Text style={{color: '#444', fontSize: 14, marginRight:10, marginBottom:5}}>{itemClass.name}</Text>
                                    )
                                })
                            :
                                <Text style={{color: '#444', fontSize: 14, marginBottom:5}}>{item.className}</Text>
                        }
                    </View>
                </View>);
    };

    _renderFavouriteItem = (data) => {
        const { item } = data;
        const tags = item.tags ? item.tags.split('\n') : [];
        return (<View style={styles.favitem}>
                    <View style={{flexDirection: 'row', alignItems: 'center'}}>
                        <TouchableOpacity style={{flexDirection: 'row', alignItems: 'center'}}
                                          onPress={() => this._handleDetails(item.id)}>
                            {this._renderUserIcon(item.userIcon)}
                            <Text style={{marginLeft: 4, color: '#444'}}>{this.props.t("say")}:</Text>
                        </TouchableOpacity>
                        <View style={{flex: 1}}/>
                        <TouchableOpacity onPress={() => this._handleFavMenu(item)}>
                            <AntdIcon name={"ellipsis1"} style={{ fontSize: 24, color: '#999' }} />
                        </TouchableOpacity>
                    </View>
                    <TouchableOpacity style={{marginTop: 8, flexDirection: 'row', alignItems: 'center',
                                              flexWrap: 'wrap'}}
                                      onPress={() => this._handleDetails(item.id)}>
                        {item.isSticky ?
                         (<View style={{backgroundColor: '#62c863', paddingHorizontal: 4,
                                        paddingVertical: 2, borderRadius: 4, marginRight: 4,
                                        alignItems: 'center', justifyContent: 'center'}}>
                              <Text style={{fontSize: 12, color: '#fff'}}>{this.props.t('stickyTag')}</Text>
                          </View>) : null}
                        {item.isDigest ?
                         (<View style={{backgroundColor: '#ef4736', paddingHorizontal: 4,
                                        paddingVertical: 2, borderRadius: 4, marginRight: 4,
                                        alignItems: 'center', justifyContent: 'center'}}>
                              <Text style={{fontSize: 12, color: '#fff'}}>{this.props.t('digestTag')}</Text>
                          </View>) : null}
                        {item.title ? item.title.split("").map(c => (<Text style={{fontSize: 16}}>{c}</Text>)) : null}
                    </TouchableOpacity>
                    {(tags && tags.length > 0) ?
                     (<View style={{marginTop: 2, flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap'}}>
                          {tags.map((tag, i) => (<Text key={i} style={{fontSize: 16, color: '#3d82f1', marginRight: 4}} onPress={() => {
                                                                       this._handleSearch('#' + tag);
                                                                   }}>
                                                     #{tag}
                                                 </Text>))}
                      </View>) : null}
                    <View style={{marginTop: 8, flexDirection: 'row', alignItems: 'center', flex:1, flexWrap:"wrap"}}>
                        {
                            item.classPostList && item.classPostList.length > 0 ?
                                item.classPostList.map((itemClass, z) => {
                                    return(
                                        <TouchableOpacity onPress={() => {
                                                              this._handleSearch(itemClass.name);
                                                          }}>
                                            <View style={{height: 24, paddingHorizontal: 10, marginRight:10,marginBottom:5,
                                                          alignItems: 'center', justifyContent: 'center',
                                                          borderWidth: 1, borderRadius: 12, borderColor: '#3d82f1'}}>
                                                <Text style={{color: '#3d82f1', fontSize: 14}}>{itemClass.name}</Text>
                                            </View>
                                        </TouchableOpacity>
                                    )
                                })
                            :
                                <TouchableOpacity onPress={() => {
                                                      this._handleSearch(item.className);
                                                  }}>
                                    <View style={{height: 24, paddingHorizontal: 10,marginBottom:5,
                                                  alignItems: 'center', justifyContent: 'center',
                                                  borderWidth: 1, borderRadius: 12, borderColor: '#3d82f1'}}>
                                        <Text style={{color: '#3d82f1', fontSize: 14}}>{item.className}</Text>
                                    </View>
                                </TouchableOpacity>
                        }
                    </View>
                    <View style={{marginTop: 8, flexDirection: 'row', alignItems: 'center',
                                  paddingTop: 10, borderTopWidth: 1, borderTopColor: '#f7f7f7'}}>
                        <TouchableOpacity onPress={() => this._handleDetails(item.id)}>
                            <View style={{flexDirection: 'row', alignItems: 'center'}}>
                                <AntdIcon name="message1" style={{ fontSize: 18, color: "#999" }} />
                                <Text style={{ marginLeft: 4, fontSize: 14, color: "#999" }}>{item.replyCount || this.props.t('reply')}</Text>
                            </View>
                        </TouchableOpacity>
                        <TouchableOpacity onPress={() => this._handleLike(item)}>
                            <View style={{flexDirection: 'row', alignItems: 'center'}}>
                                <AntdIcon name={item.isMyLike ? "like1" : "like2"}
                                          style={{ marginLeft: 30, fontSize: 18, color: (item.isMyLike ? '#fdaf2c' : "#999") }} />
                                <Text style={{ marginLeft: 4, fontSize: 14, color: "#999" }}>{item.likeCount || this.props.t('like')}</Text>
                            </View>
                        </TouchableOpacity>
                        <View style={{flex: 1}}/>
                        <Text style={{ fontSize: 14, color: "#999" }}>{dayjs.utc(item.updateOn).local().format('YYYY-MM-DD HH:mm')}</Text>
                    </View>
                </View>);
    };

    _loadMoreReply = () => {
        const { pageIndex, pageSize, hasMore } = this.props.localState.replyListParams;
        if (hasMore) {
            this.props.loadMoreReplyAsync({ pageIndex: pageIndex + 1, pageSize });
        }
    };

    _loadMoreFavourite = () => {
        const { pageIndex, pageSize, hasMore } = this.props.localState.favouriteListParams;
        if (hasMore) {
            this.props.loadMoreFavouriteAsync({ pageIndex: pageIndex + 1, pageSize });
        }
    };

    _separator = () => {
        return <View style={[styles.separator]} />;
    };

    _handleClose = () => {
        NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
    };

    _handleSearch = (keyword) => {
        NavigationService.navigateToPage(this, UIDs.screens.bbs.search, { keyword });
    };

    _handleDetails = (postId) => {
        NavigationService.navigateToPage(this, UIDs.screens.bbs.details, { postId: postId });
    };

    _handleRemoveReply = (item) => {
        const vo = {
            postId: item.postId,
            replyId: item.id,
        };
        this.props.removeReplyAsync(vo);
    };

    _handleRemoveFavourite = (item) => {
        const vo = {
            postId: item.id,
        };
        this.props.removeFavouriteAsync(vo);
    };

    _handleReplyMenu = (item) => {
        var BUTTONS = [this.props.t("delete"), this.props.t("cancel")];
        ActionSheet.show(
            {
                options: BUTTONS,
            },
            (buttonIndex) => {
                setTimeout(() => {
                    if (buttonIndex === 0) {
                        this._handleRemoveReply(item);
                    }
                }, 200);
            });
    };

    _handleFavMenu = (item) => {
        var BUTTONS = [this.props.t("removeFav"), this.props.t("cancel")];
        ActionSheet.show(
            {
                options: BUTTONS,
            },
            (buttonIndex) => {
                setTimeout(() => {
                    if (buttonIndex === 0) {
                        this._handleRemoveFavourite(item);
                    }
                }, 200);
            });
    };

    _handleLike = (item) => {
        if (item.isMyLike) {
            this.props.removeLikeAsync({postId: item.id});
        } else {
            this.props.addLikeAsync({postId: item.id});
        }
    };

    _handleAction = (item, tabIndex) => {
    };

    _handleAsyncActionError = action => {
        this.displayError(action.error);
    };
}

const styles = StyleSheet.create({
    header: {
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: "#fff",
        elevation: 0,
        borderBottomWidth:1,
        borderBottomColor:"#f4f4f4"
    },
    headerText: {
        fontSize: 18,
        fontWeight: "bold"
    },
    tabs: {
        //backgroundColor: "#ffb007",
        //width: AppSizes.screen.widthQuarter,
        //height: 4,
        height:0,
        //marginHorizontal: AppSizes.screen.width * 0.12,
        //borderRadius: 50,

    },
    tabview: {
        flex: 1,
    },
    listContainer: {
        flex: 1,
        backgroundColor: "#f7f7f7",
        paddingTop: 0,
    },
    emptyContainer: {
        flex: 1,
        backgroundColor: "#fff",
        paddingTop: 0,
    },
    noneContainer: {
        flex: 1,
        backgroundColor: "#fff",
        alignItems: "center",
        padding: 30,
    },
    noneImage: {
        width: 120,
        height: 120,
        marginTop: 30,
    },
    noneText: {
        color: "#888"
    },
    separator: {
        borderBottomColor: "#eee",
        borderBottomWidth: StyleSheet.hairlineWidth,
        marginLeft: 80
    },
    item: {
        flexDirection: "column",
        backgroundColor: "#fff",
        paddingVertical: 10,
        paddingHorizontal: 20,
        marginBottom: 4,
    },
    favitem: {
        flexDirection: "column",
        backgroundColor: "#fff",
        paddingVertical: 10,
        paddingHorizontal: 20,
        marginBottom: 4,
    },
    subitem: {
        flexDirection: "column",
        backgroundColor: "#fff",
        paddingVertical: 10,
        paddingLeft: 8,
        marginBottom: 4,
    },
    name: {
        color: "#555"
    },
    duetime: {
        color: "#888",
        fontSize: 10,
        marginTop: 5,
        lineHeight: 18
    },
    startBtn: {
        width:80,
        height:26,
        borderRadius:13,
    },
    btnText: {
        color: "#fff",
        fontSize: 12,
    },
    download: {
        width: 66,
        height: 18,
        borderRadius: 10,
        marginLeft: 5,
        marginTop: 5,
        //alignSelf: "flex-end",
        justifyContent:"center",
        alignItems:"center"
    },
    downloadText: {
        color: "#fff",
        fontSize: 8,
    },
    typetab: {
        borderRadius: 3,
        alignItems: 'center',
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 4,
        paddingBottom: 4,
    },
    typetabActive: {
        borderRadius: 3,
        backgroundColor: '#fff',
        alignItems: 'center',
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 4,
        paddingBottom: 4,
    },
    typetext: {
        color: '#868686',
    },
    typetextActive: {
        color: '#000',
    },
    tabActive: {
        paddingTop: 10,
        paddingBottom: 6,
        borderBottomColor: '#fdaf2c',
        borderBottomWidth: 4,
    },
    tabTextActive: {
        color: '#000',
    },
    tab: {
        paddingTop: 10,
        paddingBottom: 6,
        borderBottomColor: 'transparent',
        borderBottomWidth: 4,
    },
    tabText: {
        color: '#999',
    },
    topitem: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    topimg: {
        width: 40,
        height: 40,
    },
    toptextv: {
        marginLeft: 8,
        flexDirection: 'column',
    },
    toptext1: {
        fontWeight: 'bold',
        fontSize: 16,
        color: '#000',
    },
    toptext2: {
        fontSize: 12,
        color: '#999',
    },
});

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId,
        user: state.session.user,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadScreenViewAsync: (vo) => dispatch(Actions.loadScreenViewAsync(vo)),
        refreshScreenAsync: () => dispatch(Actions.refreshScreenAsync()),
        loadMorePostAsync: (vo) => dispatch(Actions.loadMorePostAsync(vo)),
        loadMoreReplyAsync: (vo) => dispatch(Actions.loadMoreReplyAsync(vo)),
        loadMoreFavouriteAsync: (vo) => dispatch(Actions.loadMoreFavouriteAsync(vo)),
        changeActiveTab: (val) => dispatch(Actions.changeActiveTab(val)),
        addLikeAsync: (vo) => dispatch(Actions.addLikeAsync(vo)),
        removeLikeAsync: (vo) => dispatch(Actions.removeLikeAsync(vo)),
        addFavouriteAsync: (vo) => dispatch(Actions.addFavouriteAsync(vo)),
        removeFavouriteAsync: (vo) => dispatch(Actions.removeFavouriteAsync(vo)),
        addReplyAsync: (vo) => dispatch(Actions.addReplyAsync(vo)),
        removeReplyAsync: (vo) => dispatch(Actions.removeReplyAsync(vo)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withTranslation(uid)(MyActivityScreen));
